import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { buildLocaleSeoLinks } from '@/i18n/seo'
import { resolveLocaleFromPath } from '@/i18n/routing'
import { getContactPageContent } from './content'

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://toolvance.com'
const CONTACT_EMAIL = 'hello@toolvance.com'

export function ContactPage() {
  const { pathname } = useLocation()
  const seoLinks = buildLocaleSeoLinks(pathname, SITE_URL)
  const { locale } = resolveLocaleFromPath(pathname)
  const content = getContactPageContent(locale)

  return (
    <>
      <Helmet>
        <title>{content.title}</title>
        <meta name="description" content={content.description} />
        <link rel="canonical" href={seoLinks.canonicalUrl} />
        {seoLinks.alternates.map(alt => (
          <link key={alt.locale} rel="alternate" hrefLang={alt.hreflang} href={alt.href} />
        ))}
        <link rel="alternate" hrefLang="x-default" href={seoLinks.xDefaultUrl} />
        <meta property="og:title" content={content.metadata.ogTitle} />
        <meta property="og:description" content={content.metadata.ogDescription} />
        <meta property="og:url" content={seoLinks.canonicalUrl} />
        <meta name="robots" content={content.metadata.robots} />
      </Helmet>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{content.content.heading}</h1>
        <p className="text-gray-600 mb-6">{content.content.intro}</p>
        <p className="text-gray-700">
          {content.content.emailPrefix}{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-brand-600 hover:text-brand-700 font-medium">
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </>
  )
}
